(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[703],{

/***/ 77740:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manufacturer/[manufacturer]",
      function () {
        return __webpack_require__(92735);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29655);


function SectionText(param) {
    var section = param.section;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "data-section-type": section.__typename,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "prose mb-3 lg:prose-xl",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_1__/* .ReactMarkdown */ .D, {
                children: section.Content
            })
        })
    });
};


/***/ }),

/***/ 87676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sections; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/sections/SectionHeader.jsx

function SectionHeader(param) {
    var section = param.section;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-section-type": section.__typename,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
            id: section.Anchor,
            className: "mb-3 font-serif text-3xl text-gray-800",
            children: section.Header
        })
    });
};

// EXTERNAL MODULE: ./components/sections/SectionText.jsx
var SectionText = __webpack_require__(78932);
;// CONCATENATED MODULE: ./components/sections/index.jsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function Sections(_param) {
    var sections = _param.sections, _className = _param.className, className = _className === void 0 ? "mb-10" : _className, props = _objectWithoutProperties(_param, [
        "sections",
        "className"
    ]);
    if (!sections || !sections.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", _objectSpread({
        className: className
    }, props, {
        children: sections.map(function(section) {
            if (section.__typename === "ComponentTextSectionHeader") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                    section: section
                }, section.id);
            }
            if (section.__typename === "ComponentTextText") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionText/* default */.Z, {
                    section: section
                }, section.id);
            }
            console.log("UNUSED SECTION", {
                section: section
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        })
    }));
}
/* harmony default export */ var sections = (Sections);


/***/ }),

/***/ 36551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);


function Throw404() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_1__["default"], {
        statusCode: 404
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Throw404);


/***/ }),

/***/ 92735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Manufacturer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/config.jsx
var config = __webpack_require__(43738);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./components/throw404.jsx
var throw404 = __webpack_require__(36551);
// EXTERNAL MODULE: ./components/sections/index.jsx + 1 modules
var sections = __webpack_require__(87676);
// EXTERNAL MODULE: ./components/global/breadcrumbs.jsx
var global_breadcrumbs = __webpack_require__(43228);
// EXTERNAL MODULE: ./components/attractions/attractions.jsx + 4 modules
var attractions = __webpack_require__(13824);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var graphql_request_dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./queries/fragments/SectionHeader.js
var SectionHeader = __webpack_require__(89847);
// EXTERNAL MODULE: ./queries/fragments/RichText.js
var RichText = __webpack_require__(17221);
;// CONCATENATED MODULE: ./queries/manufacturer.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n\n  query Manufacturer($slug: String!) {\n    manufacturers(where: { Slug: $slug }) {\n      Name\n      Slug\n      id\n      Sections {\n        ...SectionHeader\n        ...RichText\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var MANUFACTURER_QUERY = (0,graphql_request_dist.gql)(_templateObject(), SectionHeader/* default */.Z, RichText/* default */.Z);
/* harmony default export */ var queries_manufacturer = (MANUFACTURER_QUERY);

;// CONCATENATED MODULE: ./components/manufacturers/manufacturer-details.jsx









function ManufacturerDetails() {
    var ref;
    var router = (0,next_router.useRouter)();
    var variables = {
        slug: router.query.manufacturer
    };
    var ref1 = (0,dist/* default */.ZP)([
        queries_manufacturer,
        variables
    ]), data = ref1.data, error = ref1.error;
    if (error) {
        console.log(error);
    }
    if (!Array.isArray(data === null || data === void 0 ? void 0 : data.manufacturers) || !(data === null || data === void 0 ? void 0 : (ref = data.manufacturers) === null || ref === void 0 ? void 0 : ref.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(throw404/* default */.Z, {});
    }
    var manufacturer = data.manufacturers[0];
    var breadcrumbs = [
        {
            name: manufacturer.Name,
            link: "/manufacturer/[manufacturer]",
            linkAs: "/manufacturer/".concat(manufacturer.Slug)
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        manufacturer.Name,
                        " | Open Coaster"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "container m-6 mx-auto px-6 sm:px-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_breadcrumbs/* default */.Z, {
                        items: breadcrumbs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mb-10 font-serif text-5xl text-gray-800",
                        children: manufacturer.Name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sections/* default */.Z, {
                        sections: manufacturer.Sections
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb-3 font-serif text-3xl text-gray-800",
                        children: "Attractions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(attractions/* default */.Z, {
                        manufacturer: manufacturer.id
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/manufacturer/[manufacturer].jsx



var __N_SSG = true;
function Manufacturer(param) {
    var fallback = param.fallback;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(config/* default */.Z, {
        fallback: fallback,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ManufacturerDetails, {})
    });
};


/***/ }),

/***/ 17221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment RichText on ComponentTextText {\n    __typename\n    Content\n    id\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var RichText = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (RichText);


/***/ }),

/***/ 89847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SectionHeader on ComponentTextSectionHeader {\n    __typename\n    Header\n    Anchor\n    id\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SectionHeader = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (SectionHeader);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [533,269,437,774,888,179], function() { return __webpack_exec__(77740); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);